/**
 * Removes all emojis from a string
 */
export function stripEmojis(text: string): string {
  if (!text) return text;
  
  // Comprehensive regex pattern to match emojis
  const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2300}-\u{23FF}]|[\u{2B00}-\u{2BFF}]|[\u{2190}-\u{21FF}]|[\u{3030}]|[\u{FE0F}]|[\u{20E3}]|[\u{FE0E}]|[\u{203C}]|[\u{2049}]|[\u{20E3}]|[\u{2139}]|[\u{2122}]|[\u{3297}]|[\u{3299}]|[\u{25AA}]|[\u{25AB}]|[\u{25B6}]|[\u{25C0}]|[\u{25FB}]|[\u{25FC}]|[\u{25FD}]|[\u{25FE}]|[\u{2934}]|[\u{2935}]|[\u{2B05}]|[\u{2B06}]|[\u{2B07}]/gu;
  
  // Remove emojis and clean up extra spaces
  return text.replace(emojiRegex, '').replace(/\s+/g, ' ').trim();
}

/**
 * Recursively strips emojis from all string values in an object
 */
export function stripEmojisFromObject<T>(obj: T): T {
  if (obj === null || obj === undefined) {
    return obj;
  }
  
  if (typeof obj === 'string') {
    return stripEmojis(obj) as T;
  }
  
  if (Array.isArray(obj)) {
    return obj.map(item => stripEmojisFromObject(item)) as T;
  }
  
  if (typeof obj === 'object') {
    const cleaned: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        cleaned[key] = stripEmojisFromObject(obj[key]);
      }
    }
    return cleaned;
  }
  
  return obj;
}